/**
 * LaboratoryState builder — real, derivable facts about the laboratory,
 * computed from the content registries. Server-safe (no client imports).
 * Used by the Observatory page and by the AI gateway's system context.
 */

import type { LaboratoryState } from './types';
import { projects } from '../content/projects.ts';
import { research } from '../content/research.ts';
import { knowledgeNodes } from '../content/knowledge.ts';
import { publications } from '../content/publications.ts';
import { fallbackAgents } from '../content/agents.ts';

export function buildLaboratoryState(): LaboratoryState {
  return {
    status: 'active',
    activeAgents: fallbackAgents.filter((a) => a.status !== 'idle').length,
    projects: projects.length,
    researchDirections: research.length,
    knowledgeNodes: knowledgeNodes.length,
    publications: publications.length,
    updatedAt: new Date().toISOString(),
  };
}
